<template>
  <div classes="w-100">
    <div class="main-filter filter-content">
      <div class="contents">
        <div
          class="my-1"
          v-for="input in inputs"
          :key="input.id || input.keyName"
          :class="
            input.col
              ? `py-0 col-lg-${input.col} col-md-4 col-6`
              : inputs.length < 3
              ? `py-0 col-lg-${cloumnWidth}`
              : `py-0 col-lg`
          "
        >
          <!-- Status / User Type -->
          <template v-if="input.keyName === 'user_type' || input.keyName === 'status'">
            <div class="input_wrapper top_label">
              <multiselect
                v-model="data[input.keyName]"
                :options="input.statuses || input.user_types || input.options || user_types"
                label="name"
                track-by="id"
                :showLabels="false"
                :placeholder="customName || (input.keyName === 'status' ? 'الحالة' : $t(`forms.labels.${input.keyName}`))"
                :searchable="true"
                :allow-empty="true"
                @input="getInput($event, input.keyName)"
              ></multiselect>
              <label class="form-label">{{
                customName || (input.keyName === 'status' ? 'الحالة' : $t(`forms.labels.${input.keyName}`))
              }}</label>
            </div>
          </template>

          <template v-else-if="input.keyName === 'meal_store'">
            <div class="input_wrapper top_label">
              <multiselect
                v-model="data[input.keyName]"
                :options="input.meal_stores"
                label="name"
                track-by="id"
                :showLabels="false"
                :placeholder="customName || $t(`forms.labels.${input.keyName}`)"
                :searchable="true"
                :allow-empty="false"
                @input="getInput3"
              ></multiselect>
              <label class="form-label">{{
                customName || $t(`forms.labels.${input.keyName}`)
              }}</label>
            </div>
          </template>

          <template v-else-if="input.keyName === 'type'">
            <div class="input_wrapper top_label">
              <multiselect
                v-model="data[input.keyName]"
                :options="input.types || types"
                label="name"
                track-by="id"
                :showLabels="false"
                :placeholder="
                  customName2 || $t(`forms.labels.${input.keyName}`)
                "
                :searchable="true"
                :allow-empty="true"
                @input="getInput2"
              ></multiselect>
              <label class="form-label">{{
                customName2 || $t(`forms.labels.${input.keyName}`)
              }}</label>
            </div>
          </template>

          <!-- Keyword Search Input -->
          <template v-else-if="input.keyName === 'keyword'">
            <div class="input_wrapper top_label">
              <label for="searchInput" class="form-label">{{
                searchLabel || "بحث عن"
              }}</label>
              <v-text-field
                id="searchInput"
                prepend-icon="mdi-magnify"
                v-model="data[input.keyName]"
                @keyup.enter="onSearchSubmit(data[input.keyName], 'keyword')"
                @blur="onSearchSubmit(data[input.keyName], 'keyword')"
                @input="onSearchInput($event, 'keyword')"
                placeholder="بحث عن"
                clearable
                @click:clear="onSearchSubmit('', 'keyword')"
              ></v-text-field>
            </div>
          </template>

          <!-- Meal Search Input -->
          <template v-else-if="input.keyName === 'meal'">
            <div class="input_wrapper top_label">
              <label for="searchInput2" class="form-label">الوجبة</label>
              <v-text-field
                id="searchInput2"
                prepend-icon="mdi-magnify"
                v-model="data[input.keyName]"
                @keyup.enter="onSearchSubmit(data[input.keyName], 'meal')"
                @blur="onSearchSubmit(data[input.keyName], 'meal')"
                @input="onSearchInput($event, 'meal')"
                placeholder="بحث عن"
                clearable
                @click:clear="onSearchSubmit('', 'meal')"
              ></v-text-field>
            </div>
          </template>

          <!-- Keyword2 Search Input -->
          <template v-else-if="input.keyName === 'keyword2'">
            <div class="input_wrapper top_label">
              <label for="searchInput3" class="form-label">{{
                customName3
              }}</label>
              <v-text-field
                id="searchInput3"
                prepend-icon="mdi-magnify"
                v-model="data[input.keyName]"
                @keyup.enter="onSearchSubmit(data[input.keyName], 'keyword2')"
                @blur="onSearchSubmit(data[input.keyName], 'keyword2')"
                @input="onSearchInput($event, 'keyword2')"
                placeholder="بحث عن"
                clearable
                @click:clear="onSearchSubmit('', 'keyword2')"
              ></v-text-field>
            </div>
          </template>

          <!-- Start Date -->
          <template v-else-if="input.keyName === 'start_date'">
            <div class="input_wrapper top_label">
              <label class="form-label">{{
                $t(`forms.labels.${input.keyName}`)
              }}</label>
              <v-menu
                ref="dateStartModal"
                v-model="dateStartModal"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="data[input.keyName]"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :placeholder="$t(`forms.labels.${input.keyName}`)"
                  ></v-text-field>
                </template>

                <v-date-picker
                  ref="dateStartPicker"
                  v-model="data[input.keyName]"
                  no-title
                  scrollable
                  @input="onStartDateInput"
                >
                  <v-btn text color="primary" @click="clearStartDate">
                    إلغاء
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </template>

          <!-- End Date -->
          <template v-else-if="input.keyName === 'end_date'">
            <div class="input_wrapper top_label">
              <label class="form-label">{{
                $t(`forms.labels.${input.keyName}`)
              }}</label>
              <v-menu
                ref="dateEndModal"
                v-model="dateEndModal"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="data[input.keyName]"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :placeholder="$t(`forms.labels.${input.keyName}`)"
                  ></v-text-field>
                </template>

                <v-date-picker
                  ref="dateEndPicker"
                  v-model="data[input.keyName]"
                  no-title
                  scrollable
                  @input="onEndDateInput"
                >
                  <v-btn text color="primary" @click="clearEndDate">
                    إلغاء
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </template>

          <!-- Generic text input: { keyName, text: true, label, col? } -->
          <template v-else-if="input.text">
            <div class="input_wrapper top_label">
              <label class="form-label">{{ input.label || input.keyName }}</label>
              <v-text-field
                v-model="data[input.keyName]"
                @keyup.enter="onSearchSubmit(data[input.keyName], input.keyName)"
                @blur="onSearchSubmit(data[input.keyName], input.keyName)"
                @input="onSearchInput($event, input.keyName)"
                :placeholder="input.label"
                clearable
                @click:clear="onSearchSubmit('', input.keyName)"
              ></v-text-field>
            </div>
          </template>

          <!-- Generic select: { keyName, select: true, label, options: [{id, name}], col? } -->
          <template v-else-if="input.select">
            <div class="input_wrapper top_label">
              <multiselect
                v-model="data[input.keyName]"
                :options="input.options || []"
                label="name"
                track-by="id"
                :showLabels="false"
                :placeholder="input.label"
                :searchable="true"
                :allow-empty="true"
                @input="getInput($event, input.keyName)"
              ></multiselect>
              <label class="form-label">{{ input.label }}</label>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inputs: {
      required: true,
      type: Array,
    },
    user_types: {
      required: false,
      type: Array,
    },
    types: {
      required: false,
      type: Array,
    },
    meal_stores: {
      required: false,
      type: Array,
    },
    customName: {
      required: false,
      type: String,
    },
    customName2: {
      required: false,
      type: String,
    },
    customName3: {
      required: false,
      type: String,
    },
    searchLabel: {
      required: false,
      type: String,
    },
  },

  data() {
    return {
      dateStartModal: false,
      dateEndModal: false,
      data: {},
    };
  },

  computed: {
    cloumnWidth() {
      const len = this.inputs.length;
      if (len === 1) return "4";
      if (len === 2) return "6";
      if (len === 3) return "4";
      if (len === 4) return "3";
      if (len === 5) return "2";
      return "3";
    },
  },

  watch: {
    "$route.query": {
      handler(newQuery) {
        this.inputs.forEach((input) => {
          const rawVal = newQuery[input.keyName];
          let decodedVal = rawVal;
          if (typeof rawVal === "string") {
            try {
              decodedVal = decodeURIComponent(rawVal);
            } catch (e) {
              decodedVal = rawVal;
            }
          }
          const defaultVal = input.value !== undefined ? input.value : "";
          const targetVal = decodedVal !== undefined ? decodedVal : defaultVal;

          let valToSet = targetVal;
          if (input.keyName === "user_type" || input.keyName === "status") {
            const list = input.statuses || input.user_types || input.options || this.user_types || [];
            if (typeof targetVal === "string") {
              valToSet = list.find((item) => item.id == targetVal) || targetVal;
            } else if (targetVal && targetVal.id) {
              valToSet =
                list.find((item) => item.id == targetVal.id) || targetVal;
            }
          } else if (input.keyName === "type") {
            const list = input.types || this.types || [];
            if (typeof targetVal === "string") {
              valToSet = list.find((item) => item.id == targetVal) || targetVal;
            } else if (targetVal && targetVal.id) {
              valToSet =
                list.find((item) => item.id == targetVal.id) || targetVal;
            }
          } else if (input.keyName === "meal_store") {
            const list = input.meal_stores || this.meal_stores || [];
            if (typeof targetVal === "string") {
              valToSet = list.find((item) => item.id == targetVal) || targetVal;
            } else if (targetVal && targetVal.id) {
              valToSet =
                list.find((item) => item.id == targetVal.id) || targetVal;
            }
          } else if (input.select) {
            const list = input.options || [];
            valToSet = targetVal
              ? list.find((item) => item.id == (targetVal.id || targetVal)) ||
                null
              : null;
          }

          if (this.data[input.keyName] !== valToSet) {
            this.$set(this.data, input.keyName, valToSet);
          }
        });
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    onSearchInput(val, keyName) {
      const textVal =
        typeof val === "object" && val !== null && val.target
          ? val.target.value
          : val || "";
      this.$set(this.data, keyName, textVal);

      if (!this._searchTimers) this._searchTimers = {};
      clearTimeout(this._searchTimers[keyName]);
      this._searchTimers[keyName] = setTimeout(() => {
        this.updateRouteQuery(keyName, textVal);
      }, 450);
    },

    onSearchSubmit(val, keyName) {
      const textVal =
        typeof val === "object" && val !== null && val.target
          ? val.target.value
          : val !== undefined
          ? val
          : this.data[keyName] || "";

      if (!this._searchTimers) this._searchTimers = {};
      clearTimeout(this._searchTimers[keyName]);
      this.updateRouteQuery(keyName, textVal);
    },

    updateRouteQuery(keyName, val) {
      const currentQueryVal = this.$route.query[keyName] || "";
      const trimmedVal = typeof val === "string" ? val.trim() : val || "";

      if (currentQueryVal === trimmedVal) return;

      const newQuery = { ...this.$route.query, page: 1 };
      if (trimmedVal) {
        newQuery[keyName] = trimmedVal;
      } else {
        delete newQuery[keyName];
      }

      this.$router.push({ query: newQuery }).catch(() => {});
    },

    setData(event, input, query) {
      const val =
        typeof event === "object" && event !== null && event.target
          ? event.target.value
          : event;
      this.onSearchSubmit(val, query || input);
    },

    setKeyWord(event, input, query) {
      const val =
        typeof event === "object" && event !== null && event.target
          ? event.target.value
          : event;
      this.onSearchSubmit(val, query || input);
    },

    setMeal(event, input, query) {
      const val =
        typeof event === "object" && event !== null && event.target
          ? event.target.value
          : event;
      this.onSearchSubmit(val, query || input);
    },

    onStartDateInput(value) {
      this.updateRouteQuery("start_date", value);
      this.dateStartModal = false;
    },

    clearStartDate() {
      this.$set(this.data, "start_date", null);
      this.dateStartModal = false;
      this.updateRouteQuery("start_date", null);
    },

    onEndDateInput(value) {
      this.updateRouteQuery("end_date", value);
      this.dateEndModal = false;
    },

    clearEndDate() {
      this.$set(this.data, "end_date", null);
      this.dateEndModal = false;
      this.updateRouteQuery("end_date", null);
    },

    getInput(event, keyName = "user_type") {
      const targetKey = typeof keyName === "string" ? keyName : "user_type";
      if (!event) {
        const { [targetKey]: removed, ...rest } = this.$route.query;
        this.$router.push({ query: { ...rest, page: 1 } }).catch(() => {});
      } else {
        this.$router.push({
          query: Object.assign({}, this.$route.query, {
            page: 1,
            [targetKey]: event.id,
          }),
        }).catch(() => {});
      }
    },
    getInput2(event) {
      if (!event) {
        const { type, ...rest } = this.$route.query;
        this.$router.push({ query: { ...rest, page: 1 } }).catch(() => {});
      } else {
        this.$router.push({
          query: Object.assign({}, this.$route.query, {
            page: 1,
            type: event.id,
          }),
        });
      }
    },
    getInput3(event) {
      if (!event) {
        const { meal_store, ...rest } = this.$route.query;
        this.$router.push({ query: { ...rest, page: 1 } }).catch(() => {});
      } else {
        this.$router.push({
          query: Object.assign({}, this.$route.query, {
            page: 1,
            meal_store: event.id,
          }),
        });
      }
    },

    resetFields() {
      this.inputs.forEach((input) => {
        this.$set(this.data, input.keyName, null);
      });
      const resetQueries = {};
      this.inputs.forEach((input) => {
        resetQueries[input.keyName] = undefined;
      });
      this.$router
        .push({
          query: {
            ...this.$route.query,
            page: 1,
            ...resetQueries,
          },
        })
        .catch(() => {});
    },
  },

  created() {
    this.inputs.forEach((input) => {
      const rawVal = this.$route.query[input.keyName];
      let decodedVal = rawVal;
      if (typeof rawVal === "string") {
        try {
          decodedVal = decodeURIComponent(rawVal);
        } catch (e) {
          decodedVal = rawVal;
        }
      }
      const targetVal =
        decodedVal !== undefined ? decodedVal : input.value || "";

      let valToSet = targetVal;
      if (input.keyName === "user_type") {
        const list = input.user_types || this.user_types || [];
        if (typeof targetVal === "string") {
          valToSet = list.find((item) => item.id == targetVal) || targetVal;
        } else if (targetVal && targetVal.id) {
          valToSet = list.find((item) => item.id == targetVal.id) || targetVal;
        }
      } else if (input.keyName === "type") {
        const list = input.types || this.types || [];
        if (typeof targetVal === "string") {
          valToSet = list.find((item) => item.id == targetVal) || targetVal;
        } else if (targetVal && targetVal.id) {
          valToSet = list.find((item) => item.id == targetVal.id) || targetVal;
        }
      } else if (input.keyName === "meal_store") {
        const list = input.meal_stores || this.meal_stores || [];
        if (typeof targetVal === "string") {
          valToSet = list.find((item) => item.id == targetVal) || targetVal;
        } else if (targetVal && targetVal.id) {
          valToSet = list.find((item) => item.id == targetVal.id) || targetVal;
        }
      } else if (input.select) {
        const list = input.options || [];
        valToSet = targetVal
          ? list.find((item) => item.id == (targetVal.id || targetVal)) || null
          : null;
      }

      this.$set(this.data, input.keyName, valToSet);
    });
  },
};
</script>

<style scoped lang="scss">
.filter-content {
  display: flex;
  align-items: center;
  .contents {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    .v-input {
      margin: 0;
    }
  }
  .button_wrapper {
    width: fit-content;
    height: 50px;
    margin-inline-start: 10px;
    button {
      border: 0 !important;
      cursor: pointer;
    }
  }
}
</style>
